import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import propTypes from 'prop-types';

import { useAppSelector } from '@/redux';
import { NS } from '@/constants';

import DisplayNbProducts from '@/components/categ/DisplayNbProducts';

import styles from './CategFiltersDesktop.module.scss';

const Tag = dynamic(() => import('@/components/common/Tag'), { ssr: false });
Tag.displayName = 'Tag';
const TagList = dynamic(() => import('@/components/common/TagList'), { ssr: false });
TagList.displayName = 'TagList';
const SortDesktop = dynamic(() => import('@/components/categ/SortDesktop'), { ssr: false });
SortDesktop.displayName = 'SortDesktop';
const FiltersLayout = dynamic(() => import('@/components/categ/filters/FiltersLayout'), { ssr: false });
FiltersLayout.displayName = 'FiltersLayout';
const TopCategory = dynamic(() => import('@/components/categ/TopCategory'), { ssr: false });
TopCategory.displayName = 'TopCategory';

const CategFiltersDesktop = ({ selectedFiltersInfos, deleteFilter, onSortChange, categId, sort, topCategory, filters, nbTotalRows,
  onFilterChange, searchTerm, topListingRef, customClassName, onDeleteAll }) => {
  const { t } = useTranslation([NS.COMMON, NS.CATEG]);
  const { filterQuery } = useAppSelector(({ categ }) => categ);

  const classNameHeader = [
    styles['top-listing-container'],
    customClassName?.header
  ].filter(Boolean).join(' ');

  const classNameFilters = [
    styles['category-filters'],
    customClassName?.filters
  ].filter(Boolean).join(' ');

  return (
    <>
      <div className={classNameHeader} ref={topListingRef} data-rbf="categ-tag-desktop">
        <DisplayNbProducts nbTotalRows={nbTotalRows} customClassName={styles['total-products']} />
        <TagList t={t} onDeleteAll={onDeleteAll}>
          {selectedFiltersInfos.map((tag) => (
            <Tag key={tag.filterString} displayClose clickable onClose={() => deleteFilter(tag)}>
              {tag.label}
            </Tag>
          ))}
        </TagList>
        <SortDesktop t={t} selectedSort={sort} onSortChange={onSortChange} />
      </div>
      <div className={classNameFilters} data-rbf="categ-filters-desktop">
        <FiltersLayout
          filterQuery={filterQuery}
          idCateg={categId}
          onChange={onFilterChange}
          searchTerm={searchTerm}
          filters={filters}
          selectedFiltersInfos={selectedFiltersInfos}
        />
        {topCategory?.length > 0 && (
          <div className={styles['top-category']}>
            <TopCategory t={t}
              topCategory={topCategory}
              isMobileDevice={false}
              numberOfLinks={topCategory.length}
            />
          </div>
        )}
        {/** FIXME: Handle video (categ.idYoutube) here  */}
      </div>
    </>
  );
};

CategFiltersDesktop.propTypes = {
  selectedFiltersInfos: propTypes.array,
  deleteFilter: propTypes.func,
  categId: propTypes.string,
  sort: propTypes.number,
  topCategory: propTypes.array,
  filters: propTypes.array,
  nbTotalRows: propTypes.number,
  onSortChange: propTypes.func,
  onFilterChange: propTypes.func,
  searchTerm: propTypes.string,
  topListingRef: propTypes.object,
  customClassName: propTypes.object
};

export default CategFiltersDesktop;
